/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: Dashboard
 * (C) Copyright IBM Corp. 2019, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../../datatray/ExtensionBaseController',
	'./DataBehindTheVisView',
	'../../../dataSources/nls/StringResources',
	'../../../datatray/CanvasExtensionPropertyProvider'
], function(BaseController, DataBehindTheVisView, StringResources, CanvasExtensionPropertyProvider) {

	class DataBehindTheVisController extends BaseController {

		constructor(dashboard){
			super(dashboard);
			this.tabName = StringResources.get('contextualGridTabName');
			this.view = new DataBehindTheVisView({
				dashboard: dashboard
			});
		}

		/**	
		 * @see ExtensionBaseController
		 */
		getTabContrib(event, eventName, currentTabId){
			const content = this._getSelectedContent();
			if (!content) {
				return Promise.resolve(null);
			}

			return this._isContextualGridEnabled(content).then(supported => {
				if (!supported){
					return null;
				}

				const id = content.getId();
				let isSelectedOnTrayRender = false;
				let forceRender = false;
				switch (eventName) {
					case 'change:selections:select':
						isSelectedOnTrayRender = true;
						break;
					case 'splitterPanel:show':
						isSelectedOnTrayRender = event && event.sender === 'showDataBehindVisAction';
						forceRender = currentTabId === id;
						break;
					case 'dataInVis:selected':
						forceRender = (currentTabId === id) && (event && event.payloadData && event.payloadData.focusOn && id === event.sender);
						break;
					case 'widget:rerendered':
						forceRender = (currentTabId === id) && (event && event.sender === id);
						break;
				}

				return [{
					id: id,
					name: this.tabName,
					isSelectedOnTrayRender: isSelectedOnTrayRender,
					select: this.select.bind(this, { content, id, forceRender })
				}];
			});
		}

		_isContextualGridEnabled(content) {
			const state = content.getFeature('state');
			return state.whenStatusChanges(state.STATUS.RENDERED).then(() => {
				let supported = false;
				const visualization = content.getFeature('Visualization');
				if (visualization) {
					const definition = visualization.getDefinition();
					supported = !definition.getProperty('isMultilayersWidget') && !definition.getProperty('noDataQuery');
				}
				return supported;
			});
		}

		/**	
		 * @see ExtensionBaseController
		 */
		select(context, currentTabId, container){
			if(currentTabId === context.id && !context.forceRender){
				return Promise.resolve(false);
			}

			return this.view.render(context.content, container);
		}

		isSupported(){
			const showGridInConsume = this.dashboard.getCanvas().getPropertyValue(CanvasExtensionPropertyProvider.PROP_ID_SHOW_DATA_GRID_IN_CONSUME);
			const mode = this.dashboard.getMode();
			if ( !showGridInConsume ||  mode !== this.dashboard.MODES.VIEW){
				return super.isSupported();
			}else{
				return true;
			}
		}
	}

	return DataBehindTheVisController;
});